<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="mt-2">
                <b-col cols="12" md="4">
                    <ValidationProvider name="username"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('username')">
                            <b-form-input v-model="formData.username"
                                          :placeholder="$t('username')"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                    <!--                            <ValidationProvider name="registration_number"-->
                    <!--                                                rules="required"-->
                    <!--                                                v-slot="{ valid, errors }">-->
                    <!--                                <b-form-group :label="$t('registration_number')">-->
                    <!--                                    <b-form-input type="text"-->
                    <!--                                                  v-model="formData.registration_number"-->
                    <!--                                                  :placeholder="$t('registration_number')"-->
                    <!--                                                  :state="errors[0] ? false : null"/>-->
                    <!--                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>-->
                    <!--                                </b-form-group>-->
                    <!--                            </ValidationProvider>-->
                    <ValidationProvider name="title"
                                        rules=""
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('title1')">
                            <parameter-selectbox v-model="formData.title"
                                                 code="titles"
                                                 :validate-error="errors[0]"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="name"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="formData.name"
                                          :placeholder="$t('name')"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="surname"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('surname')">
                            <b-form-input v-model="formData.surname"
                                          :placeholder="$t('surname')"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="email"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('email')">
                            <b-form-input v-model="formData.email"
                                          type="email"
                                          :placeholder="$t('email')"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                        <ValidationProvider
                            name="personal_email"
                            rules="required|email"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('personal_email')">
                                <b-form-input
                                    type="text"
                                    v-model="formData.personal_email"
                                    :state="errors[0] ? false : valid ? true : null"
                                />
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>

                    <ValidationProvider name="mobile_tel"
                                        maxlength="11"
                                        rules=""
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('gsm_no')">
                            <b-form-input v-model="formData.mobile_tel"
                                          :placeholder="$t('gsm_no')"
                                          v-mask="'+1 (###)-###-####'"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="mobile_tel_country_code "
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('mobile_tel_country_code')">
                            <b-form-input type="text"
                                          v-model="formData.mobile_tel_country_code "
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>Staff ID</label>
                        <div>{{ formData.registration_number }}</div>
                    </div>

                    <ValidationProvider name="faculty_code"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('faculty')">
                            <faculty-selectbox v-model="formData.faculty_code"
                                               :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="department_code"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('department')">
                            <department-selectbox v-model="formData.department_code"
                                                  :faculty_code="formData.faculty_code"
                                                  :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="program_code"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('program')">
                            <program-selectbox v-model="formData.program_code"
                                               :faculty_code="formData.faculty_code"
                                               :department_code="formData.department_code"
                                               :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>

                    <ValidationProvider name="academic_department_code"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('academic_department')">
                            <department-selectbox v-model="formData.academic_department_code"
                                                  :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>

                    <ValidationProvider name="unit_id"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('unit')">
                            <units-selectbox v-model="formData.unit_id" :multiple="false"
                                             :validate-error="errors[0]"
                                             :state="errors[0] ? false : null"/>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="office"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('office')">
                            <b-form-input type="text"
                                          v-model="formData.office"
                                          :placeholder="$t('office')"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>

                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="contract_type"
                                        rules=""
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('workload')">
                            <parameter-selectbox code="contract_types"
                                                 type="english"
                                                 v-model="formData.contract_type"
                                                 :validate-error="errors[0]"
                                                 :state="errors[0] ? false : null"/>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="working_status"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('working_status')">
                            <parameter-selectbox code="working_statuses"
                                                 type="english"
                                                 v-model="formData.working_status"
                                                 :validate-error="errors[0]"
                                                 :state="errors[0] ? false : null"/>

                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="start_date"
                                        rules=""
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('start_date')">
                            <select-date v-model="formData.start_date"
                                         :validation-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="end_date"
                                        rules=""
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('end_date')">
                            <select-date v-model="formData.end_date"
                                         :validation-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="birthdate" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('date_of_birth')">
                            <select-date
                                :state="errors[0] ? false : (valid ? true : null)"
                                v-model="formData.birthdate"></select-date>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="gender" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('gender')">
                            <gender-selectbox
                                v-model="formData.gender"
                                :validateError="errors[0]"></gender-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <!-- Expertise Types Section -->
            <b-row class="mt-2">
                <b-col cols="12" md="4">
                    <ValidationProvider name="expertise_type" rules="" v-slot="{ errors }">
                        <b-form-group :label="$t('expertise_type')">
                            <parameter-selectbox v-model="selectedExpertiseTypes"
                                                 code="expertise_types"
                                                 :multiple="true"
                                                 :validate-error="errors[0]"
                                                 :state="errors[0] ? false : null"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="8" class="p-0">
                    <b-row v-if="selectedExpertiseTypes && selectedExpertiseTypes.length">
                        <b-col cols="12" md="6"
                               v-for="typeCode in selectedExpertiseTypes"
                               :key="typeCode">
                            <b-form-group :label="getExpertiseTypeLabel(typeCode) + ' ' + $t('description')">
                                <b-form-input v-model="expertiseDescriptions[typeCode]" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-3 mb-3">
                <b-button variant="primary"
                          @click="updateForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>

    </div>
</template>

<script>
// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
import StaffService from "@/services/StaffService";
import ParameterService from "@/services/ParameterService";
import moment from "moment";
import UnitsSelectbox from "@/components/interactive-fields/UnitsSelectbox.vue";
import GenderSelectbox from "@/components/interactive-fields/GenderSelectbox.vue";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";

export default {
    components: {
        GenderSelectbox,
        UnitsSelectbox,
        ParameterSelectbox,
        ValidationProvider,
        ValidationObserver
    },
    props: {
        staffInformation: {
            type: Object,
            default: null,
        }
    },
    created() {
        this.formId = this.$route.params.id;

        this.formData.registration_number = this.staffInformation.registration_number;
        this.formData.title = this.staffInformation.title;
        this.formData.name = this.staffInformation.name;
        this.formData.surname = this.staffInformation.surname;
        this.formData.father_name = this.staffInformation.father_name;
        this.formData.mother_name = this.staffInformation.mother_name;
        this.formData.birthdate = this.staffInformation.birthdate;
        this.formData.nationality_code = this.staffInformation.nationality_code;
        this.formData.gender = this.staffInformation.gender;

        this.formData.email = this.staffInformation.email;
        this.formData.personal_email=this.staffInformation.personal_email;
        this.formData.mobile_tel = this.staffInformation.mobile_tel;
        this.formData.mobile_tel_country_code = this.staffInformation.mobile_tel_country_code;
        this.formData.username = this.staffInformation.username;

        this.formData.faculty_code = this.staffInformation.faculty_code;
        this.formData.department_code = this.staffInformation.department_code;
        this.formData.academic_department_code = this.staffInformation.academic_department_code;
        this.formData.program_code = this.staffInformation.program_code;
        this.formData.campus_id = this.staffInformation.campus_id;
        this.formData.building_id = this.staffInformation.building_id;
        this.formData.unit_id = this.staffInformation.unit_id;
        this.formData.office = this.staffInformation.office;

        this.formData.contract_type = this.staffInformation.contract_type;
        this.formData.working_status = this.staffInformation.working_status;
        this.formData.start_date = this.staffInformation.start_date;
        this.formData.end_date = this.staffInformation.end_date;

        if (this.staffInformation.expertise_type && this.staffInformation.expertise_type.length) {
            this.selectedExpertiseTypes = this.staffInformation.expertise_type.map(t => t.type);
            this.expertiseDescriptions = {};
            this.staffInformation.expertise_type.forEach(t => {
                this.$set(this.expertiseDescriptions, t.type, t.description || '');
            });
        }

        ParameterService.getItems('expertise_types', {}).then(response => {
            this.expertiseTypeItems = response.data.data.items || [];
        });
    },
    data() {
        return {
            formId: null,
            formData: {
                father_name: null,
                mother_name: null,
                birthdate: null,
                nationality_code: null,
                gender: null,
                personal_email:null,
                registration_number: null,
                title: null,
                name: null,
                surname: null,
                username: null,
                email: null,
                mobile_tel: null,
                mobile_tel_country_code: null,
                faculty_code: null,
                department_code: null,
                academic_department_code: null,
                program_code: null,
                campus_id: null,
                building_id: null,
                unit_id: null,
                office: null,
                contract_type: null,
                working_status: null,
                start_date: null,
                end_date: null
            },
            selectedExpertiseTypes: [],
            expertiseDescriptions: {},
            expertiseTypeItems: [],
            formLoading: false,
            formProcess: false
        }
    },
    watch: {
        selectedExpertiseTypes(newVal, oldVal) {
            if (!newVal || !newVal.length) {
                this.expertiseDescriptions = {};
                return;
            }
            newVal.forEach(code => {
                if (!Object.prototype.hasOwnProperty.call(this.expertiseDescriptions, code)) {
                    this.$set(this.expertiseDescriptions, code, '');
                }
            });
            if (oldVal) {
                oldVal.forEach(code => {
                    if (!newVal.includes(code)) {
                        this.$delete(this.expertiseDescriptions, code);
                    }
                });
            }
        },
    },
    methods: {
        getExpertiseTypeLabel(code) {
            const item = this.expertiseTypeItems.find(i => i.code === code);
            return item ? item.name : code;
        },
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                let formData = {
                    ...this.formData
                }
                if (!formData.start_date){
                   delete formData.start_date
                }else{
                    formData.start_date = moment(formData.start_date).format('MM/DD/YYYY')
                }
                formData.birthdate = formData.birthdate ? moment(formData.birthdate).format('MM/DD/YYYY') : null
                formData.end_date = formData.end_date ? moment(formData.end_date).format('MM/DD/YYYY') : null;
                
                formData.expertise_type = this.selectedExpertiseTypes.map(code => ({
                    type: code,
                    description: this.expertiseDescriptions[code] || null,
                }));

                this.formProcess = true
                StaffService.update(this.formId, formData)
                    .then(response => {
                        this.$emit('updateFormSuccess', true);
                        this.$toast.success(this.$t('api.' + response.data.message));
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.formModalValidate)
                    })
                    .finally(() => {
                        this.formProcess = false
                    })
            }
        }
    }
}
</script>

